import React from 'react';

const CardHeadeWithActions = ({ children, title, icon, wImage }) => {
  return (
    <div 
      id="Header" 
      className="flex items-center justify-between border-b border-gray-200 p-4 gap-4 bg-white rounded-t-lg"
    >
      <div className="flex gap-3 items-center font-bold text-[#251658]">
        {React.isValidElement(icon) ? (
          <div className="text-[#251658] flex-shrink-0">{icon}</div>
        ) : icon ? (
          <img 
            src={icon} 
            alt="header icon" 
            className={`${wImage || 'w-8 h-8'} flex-shrink-0`}
          />
        ) : null}
        <span className="text-lg">{title}</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap justify-end">
        {children}
      </div>
    </div>
  );
};

export default CardHeadeWithActions;
